"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function uuid6() {
  return "0" + (Math.floor(Math.random() * 90000) + 10000);
}

exports.uuid6 = uuid6;